import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconicModule } from '../iconic/iconic.module';
import { SlideToggleComponent } from './slide-toggle.component';

@NgModule({
  imports: [CommonModule, IconicModule],
  declarations: [SlideToggleComponent],
  exports: [SlideToggleComponent],
})
export class SlideToggleModule {}
